// Teamspeak, SSL, VPN, Domains, Licenses translations

const services = {
  en: {
    teamspeak: {
      title: "Voice",
      titleSuffix: "Server",
      subtitle: "Teamspeak 3 server and music bot for your team or community. DDoS protected, PrePaid, and online within 120 seconds.",
      orderNow: "Order Now",
      perMonth: "/month",
      // Products
      ts3_name: "Teamspeak 3 Server",
      ts3_tagline: "Crystal-clear voice chat for friends and clans.",
      ts3_f1: "Up to 300 Slots",
      ts3_f2: "Low Ping (Frankfurt)",
      ts3_f3: "Expandable at any time",
      ts3_f4: "Unlimited Traffic",
      ts3_f5: "DDoS Protection",
      ts3_f6: "Setup in 120 seconds",
      // Highlights
      hi_ddos: "DDoS Protection",
      hi_setup: "Instant Setup",
      hi_slots: "Up to 300 Slots",
      hi_delivery: "120s Delivery",
      hi_traffic: "Unlimited Traffic",
      hi_prepaid: "PrePaid – No Contract",
      // Why section
      whyTitle: "Why Voice Servers from us?",
      why1_title: "Crystal-Clear Audio",
      why1_desc: "Our servers are connected directly to our Frankfurt network, ensuring the lowest possible ping.",
      why2_title: "Instant Setup",
      why2_desc: "Your Teamspeak server is ready within 120 seconds after payment – no waiting.",
      why3_title: "PrePaid Model",
      why3_desc: "No contracts, no surprises. Pay monthly – cancel anytime.",
      // CTA
      ctaTitle: "Your community needs a voice.",
      ctaDesc: "Professional voice communication for clans, teams, and online friends – from just €1.90/month.",
      ctaBtn: "Order Now",
    },

    ssl: {
      title: "SSL Certificates",
      subtitle: "Protect your website with trusted SSL from leading Certificate Authorities.",
      badge_popular: "Most Popular",
      from_badge: "from €8 / year",
      perYear: "/year",
      orderNow: "Order Now",
      covers: "Covers:",
      // Certificate types
      type_single: "Single Domain",
      type_wildcard: "Wildcard",
      // Benefits
      ben1_title: "No More Error Messages",
      ben1_desc: "SSL eliminates browser warnings about insecure connections on your website.",
      ben2_title: "Better SEO Ranking",
      ben2_desc: "Google prioritizes HTTPS websites in search results.",
      ben3_title: "Customer Trust",
      ben3_desc: "The padlock icon shows visitors their data is safe.",
      ben4_title: "PrePaid – No Contract",
      ben4_desc: "Don't renew after a year and it simply expires. No reminder fees.",
      // FAQ
      faqTitle: "Frequently Asked Questions",
      faq_q1: "What is SSL?",
      faq_a1: "SSL is an encryption protocol for secure data transfer. Websites with an SSL certificate are accessible via https:// instead of http://, and display a padlock icon in the browser.",
      faq_q2: "How does configuration work?",
      faq_a2: "After payment, SSL certificate configuration is activated in the customer area. You will receive an email with instructions. Make sure all domain details are entered correctly.",
      faq_q3: "How do I install the certificate?",
      faq_a3: "After configuration you will receive all necessary files as a download to include in your web server config. If you need help, open a support ticket and we will assist you.",
      faq_q4: "Which certificate do I need?",
      faq_a4: "For a single website use GoGetSSL Domain or RapidSSL. If you run multiple subdomains (shop.yourdomain.com, blog.yourdomain.com etc.), the Wildcard certificate is the right choice.",
      // Features
      feat1: "Single domain protection",
      feat2: "Automated HTTPS setup",
      feat3: "Trusted by all major browsers",
      feat4: "PrePaid – no auto-renewal",
      feat_unlimited: "Unlimited subdomains covered",
      feat_one_cert: "One certificate for everything",
      // CTA
      ctaTitle: "Not sure which certificate?",
      ctaDesc: "Our support team helps you choose the right SSL certificate for your website.",
      ctaBtn: "Contact Support",
    },

    vpn: {
      badge_prepaid: "PrePaid – No Contract",
      title: "Your Private",
      titleHighlight: "VPN",
      subtitle: "Surf anonymously and securely – at home, abroad, or on public networks.",
      perMonth: "/month",
      orderNow: "Order Now",
      // Features
      feat_traffic: "Unlimited Traffic",
      feat_locations: "38 Global Locations",
      feat_devices: "5 Devices per Account",
      feat_nologs: "No Logs Policy",
      // Use cases
      uc1_title: "Stream Without Borders",
      uc1_desc: "Access geo-restricted content from anywhere in the world.",
      uc2_title: "Secure Public Wi-Fi",
      uc2_desc: "Browse safely on public hotspots without exposing your data.",
      uc3_title: "Anonymous Browsing",
      uc3_desc: "No activity logs – your privacy is fully protected at all times.",
      uc4_title: "Works on Every Device",
      uc4_desc: "Apps for Windows, iOS, and Android. Connect up to 5 devices simultaneously.",
      // Plans section
      plansTitle: "VPN Plans",
      plansSubtitle: "One flat rate – full access to all locations and features.",
      // Plan details
      plan_monthly: "Monthly",
      plan_quarterly: "Quarterly",
      plan_yearly: "Yearly",
      plan_save: "Save",
      plan_locations: "38 server locations",
      plan_devices: "Up to 5 devices",
      plan_traffic: "Unlimited traffic",
      plan_protocols: "All protocols",
      plan_protocols_supported: "Supported Protocols",
      // CTA
      ctaTitle: "Your connection, fully private.",
      ctaDesc: "No contracts, no hidden fees. Full anonymity from €3.99/month.",
      ctaBtn: "Get Started",
    },

    domains: {
      title: "Domain",
      titleHighlight: "Registration",
      subtitle: "Secure your perfect domain – fast, simple, and at a fair price.",
      search_placeholder: "Find your domain...",
      search_btn: "Search",
      search_results: "Search Results",
      available: "Available!",
      taken: "Taken",
      search_error: "Please enter a domain name",
      popular_tlds: "Popular TLDs",
      perYear: "/year",
      register: "Register",
      transfer: "Transfer",
      // Sections
      tldTitle: "All Domain Extensions",
      tldSubtitle: "From .de to .io – we offer the most popular TLDs at fair prices.",
      whyTitle: "Why register here?",
      why1_title: "Instant Activation",
      why1_desc: "Domains are activated within minutes – ready to use right away.",
      why2_title: "PrePaid – No Auto-Renewal",
      why2_desc: "Full control over your domains. Renew only when you want to.",
      why3_title: "Easy Management",
      why3_desc: "Manage DNS, redirects and more via the customer area.",
      why4_title: "Free DNS Management",
      why4_desc: "Full DNS control included with every domain.",
      ctaTitle: "Your domain is waiting.",
      ctaBtn: "Search domain now",
    },

    licenses: {
      title: "Software",
      titleHighlight: "Licenses",
      subtitle: "Genuine software licenses for your server – flexible, affordable, PrePaid.",
      orderNow: "Order Now",
      perMonth: "/month",
      perYear: "/year",
      search_placeholder: "Search by edition, domains or feature…",
      spec_customer_accounts: "Customer Accounts",
      spec_packages: "Packages",
      // Categories
      cat_panel: "Control Panels",
      cat_os: "Operating Systems",
      cat_security: "Security",
      // Feature keys for license cards
      feat_10_domains: "Up to 10 domains",
      feat_30_domains: "Up to 30 domains",
      feat_unlimited_domains: "Unlimited domains",
      feat_wordpress: "WordPress Toolkit",
      feat_website_db: "Website & database tools",
      feat_email: "Email management",
      feat_plesk: "Full Plesk panel access",
      feat_customer_accounts: "Customer accounts",
      feat_customer_packages: "Customer packages",
      // Card descriptions
      web_admin_desc: "Perfect for managing a single server with up to 10 domains.",
      web_pro_desc: "For admins and small hosters who manage domains for multiple customers.",
      web_host_desc: "For professional hosters with no domain limit.",
      // FAQ
      faq_q1: "What is Plesk?",
      faq_a1: "Plesk is a web hosting control panel that simplifies server administration. It allows you to manage websites, databases, email accounts, and more through an intuitive web interface.",
      faq_q2: "What's the difference between Web Admin, Web Pro, and Web Host?",
      faq_a2: "Web Admin allows up to 10 domains on a single server. Web Pro allows up to 30 domains with customer accounts. Web Host has no domain limit and is ideal for hosters with many customers.",
      faq_q3: "Can I upgrade my license later?",
      faq_a3: "Yes, you can upgrade your Plesk license at any time. The price difference will be billed proportionally.",
      faq_q4: "Does the license include updates?",
      faq_a4: "Yes, as long as your license is active you will automatically receive all Plesk updates and security patches.",
      // CTA
      ctaTitle: "Need advice?",
      ctaDesc: "Our team helps you find the right license for your use case.",
      ctaBtn: "Contact Support",
    },
  },

  de: {
    teamspeak: {
      title: "Voice",
      titleSuffix: "Server",
      subtitle: "Teamspeak 3 Server und Musikbot für dein Team oder deine Community. DDoS-geschützt, PrePaid und innerhalb von 120 Sekunden online.",
      orderNow: "Jetzt bestellen",
      perMonth: "/Monat",
      ts3_name: "Teamspeak 3 Server",
      ts3_tagline: "Kristallklare Sprachkommunikation für Freunde und Clans.",
      ts3_f1: "Bis zu 300 Slots",
      ts3_f2: "Geringer Ping (Frankfurt)",
      ts3_f3: "Jederzeit erweiterbar",
      ts3_f4: "Unbegrenzter Traffic",
      ts3_f5: "DDoS-Schutz",
      ts3_f6: "Setup in 120 Sekunden",
      hi_ddos: "DDoS-Schutz",
      hi_setup: "Sofort-Setup",
      hi_slots: "Bis zu 300 Slots",
      hi_delivery: "120s Bereitstellung",
      hi_traffic: "Unbegrenzter Traffic",
      hi_prepaid: "PrePaid – kein Vertrag",
      whyTitle: "Warum Voice Server bei uns?",
      why1_title: "Kristallklarer Klang",
      why1_desc: "Unsere Server sind direkt mit unserem Frankfurter Netzwerk verbunden – geringstmöglicher Ping.",
      why2_title: "Sofort-Setup",
      why2_desc: "Dein Teamspeak-Server ist innerhalb von 120 Sekunden nach der Zahlung bereit – kein Warten.",
      why3_title: "Prepaid-Modell",
      why3_desc: "Keine Verträge, keine Überraschungen. Monatlich zahlen – jederzeit kündbar.",
      ctaTitle: "Deine Community braucht eine Stimme.",
      ctaDesc: "Professionelle Sprachkommunikation für Clans, Teams und Online-Freunde – ab nur €1,90/Monat.",
      ctaBtn: "Jetzt bestellen",
    },

    ssl: {
      title: "SSL-Zertifikate",
      subtitle: "Schütze deine Website mit vertrauenswürdigem SSL von führenden Zertifizierungsstellen.",
      badge_popular: "Beliebteste",
      from_badge: "ab €8 / Jahr",
      perYear: "/Jahr",
      orderNow: "Jetzt bestellen",
      covers: "Abdeckung:",
      type_single: "Single Domain",
      type_wildcard: "Wildcard",
      ben1_title: "Keine Fehlermeldungen mehr",
      ben1_desc: "SSL beseitigt Browser-Warnungen über unsichere Verbindungen auf deiner Website.",
      ben2_title: "Besseres SEO-Ranking",
      ben2_desc: "Google bevorzugt HTTPS-Websites in den Suchergebnissen.",
      ben3_title: "Kundenvertrauen",
      ben3_desc: "Das Schloss-Symbol zeigt Besuchern, dass ihre Daten sicher sind.",
      ben4_title: "PrePaid – kein Vertrag",
      ben4_desc: "Nicht verlängern nach einem Jahr und es läuft einfach ab. Keine Mahngebühren.",
      faqTitle: "Häufig gestellte Fragen",
      faq_q1: "Was ist SSL?",
      faq_a1: "SSL ist ein Verschlüsselungsprotokoll für die sichere Datenübertragung. Websites mit einem SSL-Zertifikat sind über https:// statt http:// erreichbar und zeigen ein Schloss-Symbol im Browser.",
      faq_q2: "Wie funktioniert die Konfiguration?",
      faq_a2: "Nach der Zahlung wird die SSL-Zertifikatskonfiguration im Kundenbereich aktiviert. Du erhältst eine E-Mail mit Anweisungen. Stelle sicher, dass alle Domain-Details korrekt eingegeben sind.",
      faq_q3: "Wie installiere ich das Zertifikat?",
      faq_a3: "Nach der Konfiguration erhältst du alle notwendigen Dateien als Download, die du in deiner Webserver-Konfiguration einbindest. Wenn du Hilfe benötigst, öffne ein Support-Ticket.",
      faq_q4: "Welches Zertifikat brauche ich?",
      faq_a4: "Für eine einzelne Website nutze GoGetSSL Domain oder RapidSSL. Wenn du mehrere Subdomains betreibst (shop.domain.de, blog.domain.de usw.), ist das Wildcard-Zertifikat die richtige Wahl.",
      feat1: "Schutz für eine Domain",
      feat2: "Automatisches HTTPS-Setup",
      feat3: "Von allen großen Browsern anerkannt",
      feat4: "PrePaid – keine automatische Verlängerung",
      feat_unlimited: "Unbegrenzte Subdomains abgedeckt",
      feat_one_cert: "Ein Zertifikat für alles",
      ctaTitle: "Nicht sicher welches Zertifikat?",
      ctaDesc: "Unser Support-Team hilft dir beim richtigen SSL-Zertifikat für deine Website.",
      ctaBtn: "Support kontaktieren",
    },

    vpn: {
      badge_prepaid: "PrePaid – kein Vertrag",
      title: "Dein privates",
      titleHighlight: "VPN",
      subtitle: "Surfe anonym und sicher – zu Hause, im Ausland oder in öffentlichen Netzwerken.",
      perMonth: "/Monat",
      orderNow: "Jetzt bestellen",
      feat_traffic: "Unbegrenzter Traffic",
      feat_locations: "38 globale Standorte",
      feat_devices: "5 Geräte pro Account",
      feat_nologs: "Keine-Logs-Politik",
      uc1_title: "Grenzenlos streamen",
      uc1_desc: "Greife auf geo-beschränkte Inhalte von überall auf der Welt zu.",
      uc2_title: "Sicheres öffentliches WLAN",
      uc2_desc: "Surfe sicher in öffentlichen Hotspots ohne deine Daten preiszugeben.",
      uc3_title: "Anonymes Surfen",
      uc3_desc: "Keine Aktivitätsprotokolle – deine Privatsphäre ist jederzeit vollständig geschützt.",
      uc4_title: "Funktioniert auf jedem Gerät",
      uc4_desc: "Apps für Windows, iOS und Android. Bis zu 5 Geräte gleichzeitig verbinden.",
      plansTitle: "VPN-Tarife",
      plansSubtitle: "Eine Flatrate – voller Zugang zu allen Standorten und Funktionen.",
      plan_monthly: "Monatlich",
      plan_quarterly: "Vierteljährlich",
      plan_yearly: "Jährlich",
      plan_save: "Spare",
      plan_locations: "38 Server-Standorte",
      plan_devices: "Bis zu 5 Geräte",
      plan_traffic: "Unbegrenzter Traffic",
      plan_protocols: "Alle Protokolle",
      plan_protocols_supported: "Unterstützte Protokolle",
      ctaTitle: "Deine Verbindung, vollständig privat.",
      ctaDesc: "Keine Verträge, keine versteckten Gebühren. Vollständige Anonymität ab €3,99/Monat.",
      ctaBtn: "Jetzt starten",
    },

    domains: {
      title: "Domain",
      titleHighlight: "Registrierung",
      subtitle: "Sichere dir deine perfekte Domain – schnell, einfach und zu einem fairen Preis.",
      search_placeholder: "Deine Domain suchen...",
      search_btn: "Suchen",
      search_results: "Suchergebnisse",
      available: "Verfügbar!",
      taken: "Vergeben",
      search_error: "Bitte einen Domain-Namen eingeben",
      popular_tlds: "Beliebte TLDs",
      perYear: "/Jahr",
      register: "Registrieren",
      transfer: "Transferieren",
      tldTitle: "Alle Domain-Endungen",
      tldSubtitle: "Von .de bis .io – wir bieten die beliebtesten TLDs zu fairen Preisen an.",
      whyTitle: "Warum hier registrieren?",
      why1_title: "Sofortige Aktivierung",
      why1_desc: "Domains werden innerhalb von Minuten aktiviert – sofort einsatzbereit.",
      why2_title: "PrePaid – keine Auto-Verlängerung",
      why2_desc: "Volle Kontrolle über deine Domains. Verlängere nur, wenn du möchtest.",
      why3_title: "Einfache Verwaltung",
      why3_desc: "Verwalte DNS, Weiterleitungen und mehr über den Kundenbereich.",
      why4_title: "Kostenlose DNS-Verwaltung",
      why4_desc: "Volle DNS-Kontrolle bei jeder Domain inklusive.",
      ctaTitle: "Deine Domain wartet.",
      ctaBtn: "Domain jetzt suchen",
    },

    licenses: {
      title: "Software",
      titleHighlight: "Lizenzen",
      subtitle: "Originale Software-Lizenzen für deinen Server – flexibel, erschwinglich, PrePaid.",
      orderNow: "Jetzt bestellen",
      perMonth: "/Monat",
      perYear: "/Jahr",
      search_placeholder: "Nach Edition, Domains oder Feature suchen…",
      spec_customer_accounts: "Kundenaccounts",
      spec_packages: "Pakete",
      cat_panel: "Control Panels",
      cat_os: "Betriebssysteme",
      cat_security: "Sicherheit",
      // Feature keys for license cards
      feat_10_domains: "Bis zu 10 Domains",
      feat_30_domains: "Bis zu 30 Domains",
      feat_unlimited_domains: "Unbegrenzte Domains",
      feat_wordpress: "WordPress Toolkit",
      feat_website_db: "Website & Datenbank-Tools",
      feat_email: "E-Mail-Verwaltung",
      feat_plesk: "Voller Plesk-Panel-Zugriff",
      feat_customer_accounts: "Kundenaccounts",
      feat_customer_packages: "Kundenpakete",
      // Card descriptions
      web_admin_desc: "Ideal für die Verwaltung eines einzelnen Servers mit bis zu 10 Domains.",
      web_pro_desc: "Für Admins und kleine Hoster, die Domains für mehrere Kunden verwalten.",
      web_host_desc: "Für professionelle Hoster ohne Domain-Limit.",
      // FAQ
      faq_q1: "Was ist Plesk?",
      faq_a1: "Plesk ist ein Webhosting-Control-Panel, das die Server-Administration vereinfacht. Damit kannst du Websites, Datenbanken, E-Mail-Konten und mehr über eine intuitive Web-Oberfläche verwalten.",
      faq_q2: "Was ist der Unterschied zwischen Web Admin, Web Pro und Web Host?",
      faq_a2: "Web Admin erlaubt bis zu 10 Domains auf einem einzelnen Server. Web Pro erlaubt bis zu 30 Domains mit Kundenaccounts. Web Host hat kein Domain-Limit und ist ideal für Hoster mit vielen Kunden.",
      faq_q3: "Kann ich meine Lizenz später upgraden?",
      faq_a3: "Ja, du kannst deine Plesk-Lizenz jederzeit upgraden. Der Preisunterschied wird anteilig berechnet.",
      faq_q4: "Sind Updates in der Lizenz enthalten?",
      faq_a4: "Ja, solange deine Lizenz aktiv ist, erhältst du automatisch alle Plesk-Updates und Sicherheitspatches.",
      // CTA
      ctaTitle: "Beratung gewünscht?",
      ctaDesc: "Unser Team hilft dir die richtige Lizenz für deinen Anwendungsfall zu finden.",
      ctaBtn: "Support kontaktieren",
    },
  },
};

export default services;
